// extracted by mini-css-extract-plugin
export default {"Registration":"Registration_Registration__lHAFO","Form":"Registration_Form__6Ld2X","Input":"Registration_Input__A7cM5"};